import App, { routes } from '@/App.tsx'
import { flattenRoutes } from '@/lib/router.ts'
import { renderToString } from 'react-dom/server'
import { StaticRouter } from 'react-router-dom/server'

interface PrerenderData {
  url: string
}

type PrerenderResult = string | {
  html?: string
  head?: {
    lang?: string
    title?: string
    elements?: Set<{
      type: string
      props: Record<string, string>
      children?: string
    }>
  }
  links?: Set<string> | string[]
} | null | undefined

const paths = flattenRoutes(routes)
  .map(route => route.path)
  .filter((p): p is string => typeof p === 'string' && !p.includes('*'))

export async function prerender(data: PrerenderData): Promise<PrerenderResult> {
  try {
    const html = renderToString(
      <StaticRouter location={data.url}>
        <App />
      </StaticRouter>,
    )

    const { parseLinks } = await import('vite-prerender-plugin/parse')

    const links = [
      ...parseLinks(html),
      ...paths,
    ]

    return {
      html,
      links,
      head: {
        lang: 'pt',
        title: '(Remix) CARLOS FELIPE',
      },
    }
  } catch (e: any) {
    console.warn(`Failed to prerender "${data.url}":`, e.message)
    return null
  }
}
